import styled from '@emotion/styled'
import { useRecoilValue } from 'recoil'

import { notifyParent } from 'mailup-react-helpers'

import {
  IconInternet,
  Link,
  LINK_VARIANT_EXTRALIGHT
} from 'mailup-web-components'

import { calendarState } from 'Pages/ScheduledSendings/recoil/state/calendar'

const StyledIcon = styled(IconInternet)`
  font-size: 14px;
  color: var(--boulder);
  margin-right: 8px;
`

const ListTimezone = () => {
  const { timezoneFormatted } = useRecoilValue(calendarState)

  const handleClick = () => {
    notifyParent('redirectMainFrame', ['form_upd_nl.aspx?visualmode=1'])
  }

  return (
    <>
      <StyledIcon />
      <Link variant={LINK_VARIANT_EXTRALIGHT} onClick={handleClick}>
        {timezoneFormatted}
      </Link>
    </>
  )
}

export default ListTimezone
